var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4774_89732",
    transform: "translate(0 -0.0272727) scale(0.0181818)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4774_89732",
    width: 55,
    height: 58,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA6CAYAAAAURcGYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAJ/SURBVGhD7Zo9SCNBFMff2SWlyXUmnaedmsqPVIJnI6KFCBZ3CBYHgqCcErG44grBwkI4uUIQLQSxEcHCz0o9Kw87P7qN3SWtKc/9b2Yh2ehm1pmddWR+Tealym/nzXtvknz4b0PvlAb2+i4xcrpi5HTFyOmKkdMVI6crRk5XjJyuCN/nHh9LZOUfWFRLMtFIyWSCRWoRkoPY99yC8+pHbnaaWls+sUgdQmlp5fN1xcDN7R1bqUVIjnc3tJQDCftM1cPvTIaJsNxHjmKB1C0UiixSh7Acb2pGsXvCculUiq38QfFRjbAcTw+LxWKU7e5ikTok7FyTb1GB2PzcTCSNXFgODA8OsFU1rhgeQBRIkct0tDsilUQtBqTIxeMx6u/rZVGZqMWAFDngLRiWpb46epEmh4KR7e5kEdHW9g7X3Bkm0uTAkF1Y3LMHsbX1DWcdFVLlsHuVlfPq7zWdnf9hkXqkyoHPdmFpbWlmEdm7t+lIRoF0OTAx/rWqNSA9eWdLXI929/bp7OJSeB4N7WdjfLDFpWUqlcpFBe0C0pmONid+DqQwdtoLhvN0uoky7W2BbvSh/iaOdFz59ZtFZSbGv1C2p3bOfEnMy+rKsvOgeAglLV2wS1OT3zwpuukIV7YJXjEQ5Hah5N8M3hQFePpoHXFbnFcMBPmySYkcwE0cheXm9p698zqCyIWalpWgB+ZmZ2hsdKRmyA4LZXIu6IM/fyxUjWphoSwtnwNF5fD4hA6OTqvOox9v8szVAxXz4PiU8nUat5ZyLig8hWLRmVQs64H+2WtXOGXfD5HSvLw5uZdAOwl6+dVG7jUor5YqMXK6YuR0xcjpipHTFSOnJ0RPynP9BS5pFycAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c6280e23e6f3688325f48727728763a2.svg";
export { ForwardRef as ReactComponent };